import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { useAppModel } from "../appModel";
import { YhBox } from "@src/components/YhBox";

export const DataBox = () => {
    const { onReset, syncData } = useAppModel();



    const action = (
        <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onReset}
            >刷新</Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => syncData()}
            >同步</Button>
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}